export interface FlashMessageSubscriptionDetailsDto
{
    getPlanName(): string;
    setPlanName(planName: string): void;
    isNewUser(): boolean;
    setIsNewUser(isUser: boolean): void;
    setExpiryDate(expiryDate: string): void;
    getExpiryDate(): string;
    setStatus(status: string): void;
    getStatus(): string;
}

export class FlashMessageSubscriptionDetailsDtoImpl implements FlashMessageSubscriptionDetailsDto
{
 
    private isUser: boolean;
    private planName: string;
    private expiryDate: string;
    private status: string;

    setStatus(status: string): void{
        this.status = status;
    }

    getStatus(): string{
        return this.status;
    }

    setExpiryDate(expiryDate: string): void {
       this.expiryDate = expiryDate;
    }
    getExpiryDate(): string {
       return this.expiryDate;
    }
    getPlanName(): string {
       return this.planName;
    }
    setPlanName(planName: string): void {
       this.planName = planName;
    }
    setIsNewUser(isUser: boolean)
    {
        this.isUser = isUser;
    }

    isNewUser(): boolean {
        return this.isUser;
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashsubscriptiondetails/flashmessagedetails.tsx